function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215686%,78.823529%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 46.933594 16.640625 L 47.117188 13.578125 C 47.117188 13.09375 47.027344 12.628906 46.886719 12.179688 L 46.886719 12.101562 L 46.863281 12.109375 C 46.640625 11.421875 46.273438 10.789062 45.75 10.261719 C 44.867188 9.378906 43.691406 8.890625 42.4375 8.886719 L 5.5625 8.886719 C 3.421875 8.886719 1.78125 10.234375 1.28125 12.171875 L 1.121094 12.101562 L 1.105469 13.40625 L 1.101562 14.007812 L 0.882812 34.433594 C 0.882812 37.011719 2.980469 39.113281 5.5625 39.113281 L 42.4375 39.113281 C 45.019531 39.113281 47.121094 37.011719 47.121094 34.433594 Z M 4.976562 13.570312 C 4.976562 13.25 5.242188 12.984375 5.566406 12.984375 L 42.4375 12.984375 C 42.636719 12.984375 42.773438 13.078125 42.851562 13.15625 C 42.929688 13.234375 43.023438 13.371094 43.023438 13.574219 L 43.023438 13.710938 L 24 21.769531 L 4.976562 13.714844 Z M 43.023438 34.433594 C 43.023438 34.753906 42.757812 35.015625 42.4375 35.015625 L 5.5625 35.015625 C 5.242188 35.015625 4.976562 34.753906 4.976562 34.433594 L 4.976562 18.183594 L 22.691406 25.683594 C 22.75 25.707031 22.8125 25.71875 22.871094 25.738281 L 24 26.21875 L 25.179688 25.726562 C 25.226562 25.710938 25.269531 25.703125 25.3125 25.6875 L 27.742188 24.65625 L 43.023438 18.273438 Z M 43.023438 34.433594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3115165480d200ce0e0b9600cd338e99.svg";
export { ForwardRef as ReactComponent };